import { Component, OnInit, Input } from '@angular/core';


export class Tile {
    value: string;
    clicked: boolean;
    disabled: boolean;
    i: number;
    j: number;
    constructor( value, clicked, disabled, i, j ) {
        this.value = value;
        this.clicked = clicked;
        this.disabled = disabled;
        this.i = i;
        this.j = j;
    }
}



@Component( {
    selector: 'ridango-msw',
    templateUrl: './msw.component.html',
    styleUrls: [ './msw.component.scss' ]
} )
export class MswComponent implements OnInit {


    @Input() fieldSize = 20;
    @Input() bombs = 60;

    gameOver = false;

    field = [];
    constructor() { }

    ngOnInit () {
        // console.log('Whadup?');
        this.generateField( this.fieldSize );
        // console.log(this.field);
    }


    generateField ( size: number ) {
        // console.log('Generating field');
        for ( let i = 0; i < size; i++ ) {
            this.field[ i ] = [];
            for ( let j = 0; j < size; j++ ) {
                this.field[ i ][ j ] = new Tile( '0', false, false, i, j );
            }
        }
        this.generateBombs( this.bombs );
    }

    generateBombs ( bombs: number ) {
        // console.log('Generating bombs', this.field);
        const i = Math.floor( Math.random() * this.fieldSize ) + 0;
        const j = Math.floor( Math.random() * this.fieldSize ) + 0;
        if ( this.field[ i ][ j ].value !== '*' ) {
            this.field[ i ][ j ] = new Tile( '*', false, false, i, j );
            bombs--;
        }
        if ( bombs === 0 ) {
            // console.log('Bombs ahead!', this.field);
            this.field = this.field.map( ( row, ii ) => {
                return row.map( ( tile: Tile, jj ) => {
                    if ( tile.value === '*' ) {
                        return tile;
                    }
                    const prevRow = ii - 1;
                    const currentRow = ii;
                    const nextRow = ii + 1;

                    const prevCol = jj - 1;
                    const currentCol = jj;
                    const nextCol = jj + 1;

                    let num = 0;

                    if ( this.field[ prevRow ] ) {
                        if ( this.field[ prevRow ][ prevCol ] && this.field[ prevRow ][ prevCol ].value === '*' ) {
                            num++;
                        }
                        if ( this.field[ prevRow ][ currentCol ] && this.field[ prevRow ][ currentCol ].value === '*' ) {
                            num++;
                        }
                        if ( this.field[ prevRow ][ nextCol ] && this.field[ prevRow ][ nextCol ].value === '*' ) {
                            num++;
                        }
                    }

                    if ( this.field[ currentRow ] ) {

                        if ( this.field[ currentRow ][ prevCol ] && this.field[ currentRow ][ prevCol ].value === '*' ) { num++; }
                        if ( this.field[ currentRow ][ currentCol ] && this.field[ currentRow ][ currentCol ].value === '*' ) { num++; }
                        if ( this.field[ currentRow ][ nextCol ] && this.field[ currentRow ][ nextCol ].value === '*' ) { num++; }

                    }

                    if ( this.field[ nextRow ] ) {

                        if ( this.field[ nextRow ][ prevCol ] && this.field[ nextRow ][ prevCol ].value === '*' ) { num++; }
                        if ( this.field[ nextRow ][ currentCol ] && this.field[ nextRow ][ currentCol ].value === '*' ) { num++; }
                        if ( this.field[ nextRow ][ nextCol ] && this.field[ nextRow ][ nextCol ].value === '*' ) { num++; }

                    }
                    tile.value = '';
                    if ( num > 0 ) {
                        tile.value = '' + num;
                    }

                    // tile.clicked = true;
                    return tile;
                } );
            } );
            return;
        }
        this.generateBombs( bombs );
    }

    tileCicked ( tile: Tile ) {

        if ( tile.value === '*' ) {
            this.gameOver = true;
            this.field.map( row => {
                return row.map( ( t: Tile ) => {
                    t.clicked = true;
                    return t;
                } );
            } );
        } else {
            this.open( [ tile ] );
        }
    }

    open ( tiles: Tile[] ) {
        // console.log('Opening', tiles.length);
        // console.log('Opening', this.field);
        if ( tiles.length === 0 ) {
            let count = 0;
            this.field.forEach( r => {
                count += r.filter( t => {
                    return t.clicked === false;
                } ).length;
            } );
            // console.log(count);
            if ( count === this.bombs ) {
                this.gameOver = true;
                this.field.map( row => {
                    return row.map( ( t: Tile ) => {
                        t.clicked = true;
                        return t;
                    } );
                } );
            }
            return;
        }
        const tile = tiles.pop();
        this.field[ tile.i ][ tile.j ].clicked = true;
        tile.clicked = true;
        if ( tile.value !== '' ) {
            let count = 0;
            this.field.forEach( r => {
                count += r.filter( t => {
                    return t.clicked === false;
                } ).length;
            } );
            // console.log(count);
            if ( count === this.bombs ) {
                this.gameOver = true;
                this.field.map( row => {
                    return row.map( ( t: Tile ) => {
                        t.clicked = true;
                        return t;
                    } );
                } );
            }
            return;
        }


        let col = this.field[ tile.i - 1 ];
        if ( col ) {
            // console.log('If 1');
            if ( col[ tile.j - 1 ] && col[ tile.j - 1 ].clicked === false && col[ tile.j - 1 ].value !== '*' ) {
                // console.log('If 2');
                // tiles.push(col[tile.j - 1]);
                if ( col[ tile.j - 1 ].value === '' && tiles.indexOf( col[ tile.j - 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j - 1 ] );
                } else {
                    this.field[ tile.i - 1 ][ tile.j - 1 ].clicked = true;
                }
            }

            if ( col[ tile.j ] && col[ tile.j ].clicked === false && col[ tile.j ].value !== '*' ) {
                // console.log('If 3');
                // tiles.push(col[tile.j]);
                if ( col[ tile.j ].value === '' && tiles.indexOf( col[ tile.j ] ) < 0 ) {
                    tiles.push( col[ tile.j ] );
                } else {
                    this.field[ tile.i - 1 ][ tile.j ].clicked = true;
                }
            }
            if ( col[ tile.j + 1 ] && col[ tile.j + 1 ].clicked === false && col[ tile.j + 1 ].value !== '*' ) {
                // console.log('If 4');
                if ( col[ tile.j + 1 ].value === '' && tiles.indexOf( col[ tile.j + 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j + 1 ] );
                } else {
                    this.field[ tile.i - 1 ][ tile.j + 1 ].clicked = true;
                }

            }
        }

        col = this.field[ tile.i ];
        if ( col ) {
            // console.log('If 1');
            if ( col[ tile.j - 1 ] && col[ tile.j - 1 ].clicked === false && col[ tile.j - 1 ].value !== '*' ) {
                // console.log('If 2');
                // tiles.push(col[tile.j - 1]);
                if ( col[ tile.j - 1 ].value === '' && tiles.indexOf( col[ tile.j - 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j - 1 ] );
                } else {
                    this.field[ tile.i ][ tile.j - 1 ].clicked = true;
                }
            }

            if ( col[ tile.j ] && col[ tile.j ].clicked === false && col[ tile.j ].value !== '*' ) {
                // console.log('If 3');
                // tiles.push(col[tile.j]);
                if ( col[ tile.j ].value === '' && tiles.indexOf( col[ tile.j ] ) < 0 ) {
                    tiles.push( col[ tile.j ] );
                } else {
                    this.field[ tile.i ][ tile.j ].clicked = true;
                }
            }
            if ( col[ tile.j + 1 ] && col[ tile.j + 1 ].clicked === false && col[ tile.j + 1 ].value !== '*' ) {
                // console.log('If 4');
                if ( col[ tile.j + 1 ].value === '' && tiles.indexOf( col[ tile.j + 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j + 1 ] );
                } else {
                    this.field[ tile.i ][ tile.j + 1 ].clicked = true;
                }

            }
        }

        col = this.field[ tile.i + 1 ];
        if ( col ) {
            // console.log('If 1');
            if ( col[ tile.j - 1 ] && col[ tile.j - 1 ].clicked === false && col[ tile.j - 1 ].value !== '*' ) {
                // console.log('If 2');
                // tiles.push(col[tile.j - 1]);
                if ( col[ tile.j - 1 ].value === '' && tiles.indexOf( col[ tile.j - 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j - 1 ] );
                } else {
                    this.field[ tile.i + 1 ][ tile.j - 1 ].clicked = true;
                }
            }

            if ( col[ tile.j ] && col[ tile.j ].clicked === false && col[ tile.j ].value !== '*' ) {
                // console.log('If 3');
                // tiles.push(col[tile.j]);
                if ( col[ tile.j ].value === '' && tiles.indexOf( col[ tile.j ] ) < 0 ) {
                    tiles.push( col[ tile.j ] );
                } else {
                    this.field[ tile.i + 1 ][ tile.j ].clicked = true;
                }
            }
            if ( col[ tile.j + 1 ] && col[ tile.j + 1 ].clicked === false && col[ tile.j + 1 ].value !== '*' ) {
                // console.log('If 4');
                if ( col[ tile.j + 1 ].value === '' && tiles.indexOf( col[ tile.j + 1 ] ) < 0 ) {
                    tiles.push( col[ tile.j + 1 ] );
                } else {
                    this.field[ tile.i + 1 ][ tile.j + 1 ].clicked = true;
                }

            }
        }

        this.open( tiles );
        // if (tile.value === '') {
        //     tile.clicked = true;
        // } else {
        //     tile.clicked = true;
        // }
    }


    restart () {
        this.generateField( this.fieldSize );
        this.gameOver = false;
    }


}
